import { Button, Modal } from 'components'
import { FormProvider, useForm } from 'react-hook-form'
import { DataList } from '../types'
import * as yup from "yup"
import toast from 'react-hot-toast'
import { useApi } from 'utils'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormSection } from "./FormSection"
import moment from 'moment'
import { useEffect } from 'react'

type ModalForms = {
  identity: string
  show: boolean
  onClose: () => void
  refetch?: () => void
}

export const ModalForm = ({ identity, show, onClose, refetch }: ModalForms) => {
  const api = useApi()
  const date = new Date()

  const defaultValues: DataList = {
    identity_batch: identity,
    transaction_date: moment(date).format("YYYY-MM-DD"),
    file_name: "",
    file_description: ""
  }
  const validationSchema = yup.object().shape({
    identity_batch: yup.string().label("Identity batch").required(),
    file_name: yup.string().label("Employee import name").required().max(100, "Must be 100 characters or less"),
    file_description: yup.string().label("Description").required(),
  })
  const onSubmit = (value: DataList) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(`/import-employee/save-preview`, value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => {
        refetch && refetch()
        onClose()
        methods.reset()
      })
      .catch(() => {})
      .finally(resolve)
    })
  }
  const methods = useForm<DataList>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })

  useEffect(() => {
    if (identity) {
      methods.reset({ 
        identity_batch: identity,
        transaction_date: moment(date).format("YYYY-MM-DD")
      });
    }
    // eslint-disable-next-line
  }, [identity, methods.reset]);

  return (
    <div>
      {show && (
        <Modal isOpen title="EMPLOYEE IMPORT" closeModal={onClose}>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Modal.Body>
                <FormSection />
              </Modal.Body>

              <Modal.Footer className="text-end">
                <Button 
                  type="submit" 
                  color="primary" 
                  loading={methods.formState.isSubmitting ? "true" : undefined}
                >
                  SAVE
                </Button>
              </Modal.Footer>
            </form>
          </FormProvider>
        </Modal>
      )}
    </div>
  )
}